import env from '../config/env'
import organizations from '../config/oragnizations'

const isNotYouEndPoint = (organizationId) => `${env.REDIRECT_ENDPOINT}/logout?redirectUrl=${organizations.get(organizationId).landing_page_url}`

export default isNotYouEndPoint
